"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function gold(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12 3.1875C7.1325 3.1875 3.1875 7.1325 3.1875 12C3.1875 16.8675 7.1325 20.8125 12 20.8125C16.8675 20.8125 20.8125 16.8675 20.8125 12C20.8125 9.66278 19.884 7.42129 18.2314 5.76862C16.5787 4.11596 14.3372 3.1875 12 3.1875ZM12 18.615C10.2456 18.615 8.56304 17.9181 7.32249 16.6775C6.08194 15.437 5.385 13.7544 5.385 12C5.385 10.2456 6.08194 8.56304 7.32249 7.32249C8.56304 6.08194 10.2456 5.385 12 5.385C13.7544 5.385 15.437 6.08194 16.6775 7.32249C17.9181 8.56304 18.615 10.2456 18.615 12C18.615 13.7544 17.9181 15.437 16.6775 16.6775C15.437 17.9181 13.7544 18.615 12 18.615ZM9.8025 12.0075L12.0075 15.3075L14.1975 12.0075L12.0075 8.7L9.8025 12.0075Z", fill: color }));
}
exports["default"] = gold;
//# sourceMappingURL=gold.js.map